<template>
  <div>
  
   
    <vx-card>
    <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Unmatched Campaign Contacts</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
      <vs-table class="mb-10" stripe :data="records">
        <template slot="thead">
          <vs-th sort-key="s_no">S No.</vs-th>
          <vs-th sort-key="Steps">Campaign</vs-th>
          <vs-th sort-key="Steps_description">Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr]">
              {{ indextr + 1 }}
            </vs-td>
            <vs-td :data="data[indextr].campaign_name">
              {{ data[indextr].campaign_name }}
            </vs-td>
            <vs-td>
              <vs-button @click="showUnmatchedContacts(data[indextr].campaign_id)" color="primary" type="border"
            >View</vs-button
          >
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import defineAbilitiesFor from "@/config/abilities";
import axios from "@/axios.js";
import JsonExcel from "vue-json-excel";

export default {
  components: {
    downloadExcel: JsonExcel
  },
  data() {
    return {
      json_fields: {
        Company: "ml_company",
        Address: "ml_addresses"
      },
      campaignName: null,
      abilities: null,
      records: []
    };
  },
  computed: {},
  methods: {
    showUnmatchedContacts: function(campaign_id) {
      this.$router.replace("/contacts/unmatched/" + campaign_id);
    },
    goBack: function() {
      this.$router.go(-1);
    },
    getCampaigns() {
      axios
        .get(this.$base_url + "/api/contacts/get_unmatched_campaign_list")
        .then(response => {
          this.records = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    this.getCampaigns();
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    this.campaignName = this.$route.params.campaignName;
  }
};
</script>
